export default __webpack_public_path__ + "static/media/add-section.ea83574c.svg";